import React from 'react';
import classNames from 'classnames/bind';
import { LuUserCircle, LuBuilding2, LuShieldCheck } from 'react-icons/lu';

import styles from './Account.module.scss';

const cx = classNames.bind(styles);

function OverviewPanel({
    totalUsers,
    totalDepartments,
    totalPositions,
    onOpenDepartments,
    onOpenPositions,
}) {
    return (
        <div className={cx('overview-panel')}>
            <div className={cx('overview-card')}>
                <span className={cx('overview-card__icon')}><LuUserCircle /></span>
                <div>
                    <p>Tổng người dùng</p>
                    <strong>{totalUsers}</strong>
                </div>
            </div>
            <div
                className={cx('overview-card', 'overview-card--clickable')}
                role="button"
                tabIndex={0}
                onClick={onOpenDepartments}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onOpenDepartments();
                    }
                }}
            >
                <span className={cx('overview-card__icon')}><LuBuilding2 /></span>
                <div>
                    <p>Chức vụ</p>
                    <strong>{totalDepartments}</strong>
                </div>
            </div>
            <div
                className={cx('overview-card', 'overview-card--clickable')}
                role="button"
                tabIndex={0}
                onClick={onOpenPositions}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onOpenPositions();
                    }
                }}
            >
                <span className={cx('overview-card__icon')}><LuShieldCheck /></span>
                <div>
                    <p>Phòng ban</p>
                    <strong>{totalPositions}</strong>
                </div>
            </div>
        </div>
    );
}

export default OverviewPanel;
